import React from "react";
import { useSelector } from "react-redux";
import UsedInLink from "../UsedInLink";
import { selectEventHandlers } from "../../../store/slices/projectSlice";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import SidebarScroll from "./SidebarScroll";
import SidebarCollapseButton from "./SidebarCollapseButton";

export default function Modules() {
  const eventHandlers = useSelector(selectEventHandlers);
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-center">
        <h5 className="card-title mb-0">
          Modules
          <HelpButton helpKey="modules" />
        </h5>
        <SidebarCollapseButton
          collapsed={collapsed}
          onClick={() => setCollapsed((value) => !value)}
        />
      </div>
      {!collapsed && (
        <div className="card-body p-0">
          {eventHandlers.filter((eh) => eh.IsModule).length > 0 ? (
            <SidebarScroll>
              <ul className="list-group list-group-flush">
                {eventHandlers
                  .filter((eh) => eh.IsModule)
                  .map((eventHandler) => (
                    <li key={eventHandler.UUID} className="list-group-item p-2">
                      <div className="d-flex justify-content-between align-items-baseline">
                        <span className="">{eventHandler.Label}</span>
                        <UsedInBadge arg={eventHandler} />
                      </div>
                    </li>
                  ))}
              </ul>
            </SidebarScroll>
          ) : (
            <div className="text-center m-1">No modules</div>
          )}
        </div>
      )}
    </div>
  );
}
